import { Col, Container, Row, Stack } from "react-bootstrap"

const HireBackendDeveloperContent = () => {
    return (
        <Container className="hire-content-container">
            <Row>
                <Col>
                    <Stack className="hire-content-info">
                        <h2>
                            Hire Skilled Backend Developers for Powerful Web Applications
                        </h2>
                        <p>
                            Need a reliable backend to power your web or mobile application? Our backend developers specialize in building secure, scalable, and high-performance server-side architectures using technologies like Node.js, Laravel, PHP, Python, and more.
                        </p>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>
                            Why Hire Backend Developers from Us?
                        </h2>
                        <ul>
                            <li>
                                <b>Expertise in Multiple Backend Technologies</b>
                                <p>
                                    From Node.js and Laravel to Core PHP and Python — our developers craft RESTful APIs, microservices, and full-stack systems with clean, maintainable code.
                                </p>
                            </li>
                            <li>
                                <b>Secure & Scalable Architecture</b>
                                <p>
                                    We follow best practices for application security, performance optimization, and scalable backend design to ensure your app runs smoothly under any load.
                                </p>
                            </li>
                            <li>
                                <b>API Development & Integration</b>
                                <p>
                                    Our team builds custom APIs and integrates third-party services such as payment gateways, CRMs, ERP systems, and cloud platforms seamlessly.
                                </p>
                            </li>
                            <li>
                                <b>Database Design & Optimization</b>
                                <p>
                                    We architect and optimize databases (MySQL, PostgreSQL, MongoDB, etc.) for fast access, data integrity, and scalability.
                                </p>
                            </li>
                            <li>
                                <b>Flexible Hiring Models</b>
                                <p>
                                    Choose from hourly, part-time, or full-time backend developers to fit your technical needs and budget.
                                </p>
                            </li>
                        </ul>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>
                            Our Backend Development Services
                        </h2>
                        <ul>
                            <li>Custom Web & App Backend Development</li>
                            <li>RESTful API & Microservice Architecture</li>
                            <li>Authentication & Security Implementations</li>
                            <li>Real-time App Backend (Sockets, WebRTC)</li>
                            <li>Database Design, Migration & Management</li>
                            <li>Third-party API Integration</li>
                            <li>Ongoing Maintenance & Support</li>
                        </ul>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>
                            Power Your Project with a Reliable Backend Team
                        </h2>
                        <p>
                            Our backend developers ensure your application runs smoothly, securely, and efficiently — laying the foundation for a seamless user experience. Contact us today to discuss your backend project requirements.
                        </p>
                    </Stack>
                </Col>
            </Row>
        </Container>
    )
}

export default HireBackendDeveloperContent;
